import React, { useEffect, useLayoutEffect, useState } from 'react'
import '../Style/Product_Information.css'
import { useParams } from 'react-router-dom'
import MoneyIcon from '../Logos/money-alt-cash-currency.svg'
import CalenderIcon from '../Logos/calendar.svg'
import PencilIcon from '../Logos/pencil.svg'
import ProductIcon from '../Logos/ad-product.svg'
import Product_Image from '../Product_Images/516823.jpg'
import ArrowRight from '../Logos/chevron-right-arrow (1).svg'
import ArrowLeft from '../Logos/chevron-left-arrow.svg'
import Comment from '../Components/Comment_Component'
import axios from 'axios'
import CommentIcon from '../Logos/comment-chat-message.svg'
import SendIcon from '../Logos/send.svg'
import Loading_Screen from '../Components/Loading_Screen'



function Product() {
    const { ProductSection, Production } = useParams()
    const [ProductData, SetProductData] = useState()
    const [CommentData, SetCommandData] = useState()
    const [Colors, SetColors] = useState()
    const [Offer, SetOffer] = useState()
    const [Loading, SetLoading] = useState(true)

    // axios.post("http://127.0.0.1:3001/get-product", {ProductSection, Production})
    //     .then(data => {
    //         SetProductData(data.data[0])
    //         SetCommandData(JSON.parse(data.data[0].comments))
    //     })
    //     .catch(err => {console.log(err)})
    useEffect(() => {
        axios.post("http://127.0.0.1:3001/get-product", { ProductSection, Production })
            .then(data => {
                SetProductData(data.data[0])
                SetCommandData(JSON.parse(data.data[0].comments))
                SetColors(JSON.parse(data.data[0].colors))
                SetOffer(JSON.parse(data.data[0].offer))
            })
            .catch(err => { console.log(err) })
    }, [])

    return (
        <>
            <main onLoad={() => { SetLoading(false) }}>
                {Loading ? <Loading_Screen /> : null}
                <div className='product-information'>
                    <div className='first-section'>
                        <div className='details-container'>
                            {ProductData && Offer ? <div className='offer-percent'>{Offer.offer_percent}%</div> : null}
                            <div className='product-name'>{ProductData && ProductData.name ? ProductData.name : null}</div>
                            <div className='other-details'>
                                <div className='dates-container'>
                                    <div className='added-date'>
                                        <div className='added-date-text'>تاریخ افزودن: {ProductData && ProductData.added_date ? ProductData.added_date : null}</div>
                                        <img src={CalenderIcon} className='calender-icon' />
                                    </div>
                                    <div className='updated-date'>
                                        <div className='updated-date-text'>تاریخ بروزرسانی: {ProductData && ProductData.updated_date ? ProductData.updated_date : "اخرین بروزسانی وجود ندارد"}</div>
                                        <img src={CalenderIcon} className='calender-icon' />
                                    </div>
                                </div>
                                <div className='number-of-product'>
                                    <div className='number-of-product-text'>
                                        <div className='text'>تعداد باقیمانده در انبار:</div>
                                        {ProductData && ProductData.number > 0 ? <div className='number-of-product-shower'>{ProductData.number}</div> : <div className='out-of-number-of-product-shower'>ناموجود</div>}
                                    </div>
                                    <img src={ProductIcon} className='product-icon' />
                                </div>
                                <div className='product-colors'>
                                    <div className='title'>رنگ های موجود</div>
                                    <div className='product-color-lister'>
                                        {Colors ? Colors.map((Colors, Key) => {
                                            return <div className='product-color' style={{ backgroundColor: `${Colors}` }}></div>
                                        }) : "رنگی تعریف نشده است"}
                                    </div>
                                </div>
                            </div>
                            <div className='price-container'>
                                <div className='price'>
                                    <i class="icony icony-toman price-icon"></i>
                                    <div className={Offer ? 'last-price' : 'price-text'}>{ProductData && ProductData.price ? ProductData.price : null}</div>
                                    {Offer ? <div className='offered-price'>
                                        <i class="icony icony-toman price-icon"></i>{Offer.offered_price}</div> : null}


                                    {/* {Product_Data.Product_Data.number <= 0 ? <div className='out-of-number-container'>
                                        <div className='wrapper'></div>
                                        <div className='text'>ناموجود</div>
                                    </div> : Offer ? <><div className='offered-price'>{Offer.offered_price} تومان</div>
                                    <img src={MoneyIcon} className='money-icon' /> <div className={Offer && Product_Data.Product_Data.number != 0 ? "last-price" : "price-text"}>{Product_Data.Product_Data && Product_Data.Product_Data.price ? Product_Data.Product_Data.price : "N/A"} تومان</div></> : <><img src={MoneyIcon} className='money-icon' /> <div className={Offer && Product_Data.Product_Data.number != 0 ? "last-price" : "price-text"}>{Product_Data.Product_Data && Product_Data.Product_Data.price ? Product_Data.Product_Data.price : "N/A"} تومان</div></>} */}
                                    {/* <div className='offered-price'> {Offer.offered_price} تومان</div> */}
                                    {/* <img src={MoneyIcon} className='money-icon' /> */}
                                    {/* <div className={Offer && Product_Data.Product_Data.number != 0 ? "last-price" : "price-text"}>{Product_Data.Product_Data && Product_Data.Product_Data.price ? Product_Data.Product_Data.price : "N/A"} تومان</div> */}
                                </div>
                                {ProductData && ProductData.number > 0 ? <div className='add-to-cart-button'>افزودن به سبد خرید</div> : <div className='out-of-number-container'>
                                    <div className='wrapper'></div>
                                    <div className='text'>ناموجود</div>
                                </div>}

                            </div>
                        </div>
                        <div className='product-pictures-container'>
                            <div className='showing-picture' style={{ backgroundImage: `url(${Product_Image})` }}></div>
                            <div className='pictures-container'>
                                <div className='arrowleft'>
                                    <img src={ArrowLeft} alt='arrowleft' />
                                </div>
                                <div className='pictures-slider'>
                                    <div className='picture-slide' style={{ backgroundImage: `url(${Product_Image})` }}></div>
                                    <div className='picture-slide' style={{ backgroundImage: `url(${Product_Image})` }}></div>
                                </div>
                                <div className='arrowright'>
                                    <img src={ArrowRight} alt='arrowright' />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='second-section'>
                        <div className='product-description-container'>
                            <div className='title'>توضیحات</div>
                            <div className='description'>{ProductData && ProductData.description ? ProductData.description : null}</div>
                        </div>
                        <div className='product-comments'>
                            <div className='title'>کامنت ها</div>
                            <form className='add-comment'>
                                <div className='input-section'>
                                    <img src={CommentIcon} />
                                    <input type='text' name='comment' className='add-comment-input' placeholder='کامنت...' />
                                </div>
                                <button type='submit' className='send-comment-button'></button>
                            </form>
                            {CommentData ? CommentData.map((Comments, key) => {
                                return <Comment Comment_Data={Comments} />
                            }) : <div className='no-comment'>کامنتی وجود ندارد</div>}
                        </div>
                    </div>
                </div>
            </main>
        </>
    )
}

export default Product